import { FC, Fragment, useEffect, useState } from 'react'
import cn from './index.module.css'
import FolderItem from './components/FolderItem/FolderItem'
import { fetchCatalogFolders, fetchSubFolders } from './api'
import classNames from 'classnames'

interface IFolderList {
  selectedFolder?: number
  selectedSubFolder?: number
  className?: string
  onSelect: (value: { folder?: number; subFolder?: number }) => void
}

const FolderList: FC<IFolderList> = ({
  selectedFolder,
  selectedSubFolder,
  className,
  onSelect,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [folders, setFolders] = useState<IFolder[]>([])
  const [subFolders, setSubFolders] = useState<ISubFolder[]>([])

  useEffect(() => {
    async function fetch() {
      setIsLoading(true)
      const folders = await fetchCatalogFolders()
      const subFolders = await fetchSubFolders()

      setFolders(folders)
      setSubFolders(subFolders)
      onSelect({ folder: folders?.[0]?.id })
      setIsLoading(false)
    }

    fetch()
  }, [])

  const onFolder = (folder: IFolder) => {
    if (folder.id !== selectedFolder || selectedSubFolder)
      onSelect({ folder: folder.id })
  }

  const onSubFolder = (folder: ISubFolder) => {
    if (folder.id !== selectedSubFolder)
      onSelect({ folder: folder.parent_id, subFolder: folder.id })
  }

  return (
    <div className={classNames(cn.wrapper, className)}>
      <div className={cn.header}>Фильтры</div>
      <div className={cn.folderList}>
        {folders?.map((folder) => {
          const subList = subFolders?.filter(
            (item) => item.parent_id === folder.id,
          )

          return (
            <Fragment key={folder.id}>
              <div >
                <FolderItem
                  label={folder.name}
                  value={selectedFolder === folder.id && !selectedSubFolder}
                  onChange={() => onFolder(folder)}
                />
              </div>
              {subList?.map((subFolder) => {
                return (
                  <div
                    className={cn.subFolderWrapper}
                    key={'sub' + subFolder.id}
                  >
                    <FolderItem
                      label={subFolder.name}
                      value={selectedSubFolder === subFolder.id}
                      onChange={() => onSubFolder(subFolder)}
                    />
                  </div>
                )
              })}
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}

export default FolderList
